import React from 'react';
import Text from './Text';

/**
 * EGGS Textarea Component
 */
export default function Textarea({
  label,
  error,
  helperText,
  required = false,
  rows = 4,
  className = '',
  ...props
}) {
  const textareaClasses = [
    'w-full',
    'px-4 py-3',
    'font-burns font-extralight text-base',
    'text-eggs-dark',
    'bg-white',
    'border rounded-lg',
    'transition-all duration-200',
    'focus:outline-none focus:ring-2 focus:ring-offset-1',
    'resize-vertical',
    error 
      ? 'border-error focus:ring-error' 
      : 'border-gray-300 focus:border-eggs-yellow focus:ring-eggs-yellow',
    'disabled:bg-gray-100 disabled:cursor-not-allowed',
    'placeholder:text-gray-400'
  ].join(' ');

  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block">
          <Text type="Body" variant="sm" weight="Strong">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </Text>
        </label>
      )}
      <textarea className={textareaClasses} rows={rows} {...props} />
      {(error || helperText) && (
        <Text 
          type="Body" 
          variant="xs" 
          className={error ? 'text-error' : 'text-gray-500'}
        >
          {error || helperText}
        </Text>
      )}
    </div>
  );
}
